import { APIGet, APIUrl, AdminType } from "api/protocols";

interface IGetScorecards {
  facility_id: number;
  league_id?: number;
  tournament_id?: number;
  tee_sheet_id: number;
  start_time: string;
  frontDivision?: number;
  backDivision?: number;
}

interface IGetCount{
  count: number;
}
export async function GetEventScorecards(params: IGetScorecards, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.FacilityAdmin, "/event/scorecards"), params, useGlobalLoader);
}

export async function GetEventScorecardsCount(params: any, useGlobalLoader: boolean) {
  return await APIGet<IGetCount>(APIUrl(AdminType.FacilityAdmin, "/event/scorecards/count"), params, useGlobalLoader);
}
